import axios from 'axios';

import {getVisitorId} from 'libs/user/getVisitorId';
import {RELEASE_VERSION, SITE_ID} from 'constants/app';
import {SITE_URL, HTTP_REQUEST_HEADER, HTTP_REQUEST_HEADER_CONTENT_TYPE_VALUE} from 'constants/api';
import {
    API_CLIENT_KEY,
    DY_HOST,
    DY_HOST_ENGAGEMENT,
    DY_REQUEST_TIMEOUT,
} from 'features/experiments/constants';

export const instanceGusaBackend = axios.create({
    baseURL: SITE_URL,
});
instanceGusaBackend.defaults.headers.common = {
    Accept: 'application/json',
    'X-Visitor-Id': getVisitorId(),
    website: SITE_ID.toString(),
    releaseTag: RELEASE_VERSION || '',
};

export const instanceDyChoose = axios.create({
    baseURL: DY_HOST,
    headers: {
        [HTTP_REQUEST_HEADER.CONTENT_TYPE]: HTTP_REQUEST_HEADER_CONTENT_TYPE_VALUE.APPLICATION_JSON,
        [HTTP_REQUEST_HEADER.DY_API_KEY]: API_CLIENT_KEY,
    },
    timeout: DY_REQUEST_TIMEOUT,
});

export const instanceDyEngagement = axios.create({
    baseURL: DY_HOST_ENGAGEMENT,
    headers: {
        [HTTP_REQUEST_HEADER.CONTENT_TYPE]: HTTP_REQUEST_HEADER_CONTENT_TYPE_VALUE.APPLICATION_JSON,
        [HTTP_REQUEST_HEADER.DY_API_KEY]: API_CLIENT_KEY,
    },
});
